import React, { useEffect, useState } from 'react'
import Banner from "./components/Banner/Index";
import { CircularProgress } from "@mui/material";
import BusinessEnquiry from "./components/Forms/Enquiry";
import Featureslider from './components/Gallery/Featureslider';
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import Overview from './components/Aboutus/Overview';

const Manufacturing = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fatchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/manufacturing_plant.php`);
        setPageData(response.data);
      }
      catch (err) {
        setError(err.message);
      }
      finally {
        setloading(false);
      }
    };
    fatchData();
  }, []);
  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error)
    return (
      <div>Error: An error occurred while fetching data</div>
    );
  if (!pageData) return null;
  const { bannerData, overview, infrastructureBox, staticfeature } =
    pageData;

  return (
    <main>
      <Banner Data={bannerData[0]} />
      {overview && <Overview Data={overview} infrastructure={true} listingClass={'servicePage'} _class={'text-lg-center text-start'}/>}
      {infrastructureBox && <Featureslider Data={infrastructureBox} slidesPerView={2.7} secondSlider={'hoverEffect'} spaceBetween={50} ImageHeight={'400'} ImageWidth={'600'} />}
      {staticfeature && <Featureslider Data={staticfeature} slidesPerView={1.9} spaceBetween={50} />}
      <BusinessEnquiry />
    </main>
  )
}

export default Manufacturing